/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".imageStyle[_ngcontent-%COMP%]{margin-top:50px;margin-left:100px}.imgStyle[_ngcontent-%COMP%]{margin-left:20px;margin-right:20px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/themes/default/css/member-documents.component.less.shim.ngstyle.js.pre-build-optimizer.js